import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasProvisionnominaconpagosSucursales', {
    bindings: {
      fechaInicio: '<',
      fechaFin: '<',
      idsEmpresas: '<',
      idOperadora: '<',
      idsNominas: '<',
    },
    template,
    controller: Controller,
  })

function Controller (ContabilidadPolizas, $catalogos, $location) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.actualizarEmpresas = actualizarEmpresas
  $ctrl.traerNominas = traerNominas
  $ctrl.buscar = buscar

  function $onInit () {
    $ctrl.$promise = $catalogos.get('empresas')
    $ctrl.nominas = undefined
    $ctrl.opciones = {
      fecha_inicio: $ctrl.fechaInicio || new Date(),
      fecha_fin: $ctrl.fechaFin || new Date(),
      ids_empresas: $ctrl.idsEmpresas || undefined,
      id_operadora: $ctrl.idOperadora || undefined,
      ids_nominas: $ctrl.idsNominas || undefined,
    }
    traerNominas()
  }

  function actualizarEmpresas (data) {
    $ctrl.opciones.ids_empresas = data.ids_empresas
    $ctrl.opciones.id_operadora = data.idOperadora
    $ctrl.opciones.ids_nominas = undefined
    traerNominas()
  }

  function traerNominas () {
    if (!$ctrl.opciones.id_operadora) return
    if (!$ctrl.opciones.ids_empresas || $ctrl.opciones.ids_empresas.length === 0) return
    if (!$ctrl.opciones.fecha_inicio || !$ctrl.opciones.fecha_fin || $ctrl.opciones.fecha_inicio > $ctrl.opciones.fecha_fin) return

    ContabilidadPolizas.traerNominas(
      $ctrl.opciones.fecha_inicio,
      $ctrl.opciones.fecha_fin,
      $ctrl.opciones.id_operadora,
      $ctrl.opciones.ids_empresas,
    ).then(function (data) {
      $ctrl.nominas = data
    })

    $ctrl.opciones.ids_nominas = $ctrl.idsNominas || undefined
  }

  function buscar () {
    $location.replace()
    $location.search({
      fechaInicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fechaFin: $ctrl.opciones.fecha_fin.toYMD(),
      idsEmpresas: $ctrl.opciones.ids_empresas,
      idOperadora: $ctrl.opciones.id_operadora,
      idsNominas: $ctrl.opciones.ids_nominas,
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisionnominaconpagossucursales/component.js